export const SMART_TASK_PROPERTY_NAME = 'EntityExtraction/RequestForAction1.0';

export enum TaskType {
    Todo,
    Reminder,
}
